import { render, staticRenderFns } from "./SelectContext.vue?vue&type=template&id=22e453d2&"
import script from "./SelectContext.vue?vue&type=script&lang=js&"
export * from "./SelectContext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports